import { useContext, useMemo } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Central readiness hook combining auth and future capability loading.
 * Currently proxies AuthContext.loading; extend when capability fetch states exist.
 */
export function usePermissionReadiness() {
  const auth = useContext(AuthContext);
  const isReady = useMemo(() => {
    // Extend here: e.g., const capsLoading = useCapabilitiesLoading();
    // return !auth?.loading && !capsLoading;
    return !(auth && auth.loading);
  }, [auth]);
  return { isReady };
}
